import React from 'react';

// Base skeleton animation styles
const skeletonBaseClass = "animate-pulse bg-gray-300 dark:bg-gray-600 rounded";

// Reusable skeleton components for different UI elements

export const GameBoardSkeleton = ({ gridSize = 3 }) => {
  const cells = Array(gridSize * gridSize).fill(null);

  return (
    <div className="mb-4">
      <div className={`${skeletonBaseClass} h-6 w-32 mb-4`}></div>
      <div className={`grid grid-cols-${gridSize} gap-2 max-w-xs mx-auto`}>
        {cells.map((_, index) => (
          <div key={index} className={`${skeletonBaseClass} aspect-square`}></div>
        ))}
      </div>
    </div>
  );
};

export const PlayerInfoSkeleton = () => (
  <div className="mb-4 p-4 border rounded-lg">
    <div className={`${skeletonBaseClass} h-4 w-20 mb-2`}></div>
    <div className={`${skeletonBaseClass} h-6 w-48 mb-2`}></div>
    <div className={`${skeletonBaseClass} h-4 w-32`}></div>
  </div>
);

export const GameStatusSkeleton = () => (
  <div className="mb-4 text-center">
    <div className={`${skeletonBaseClass} h-6 w-48 mx-auto mb-2`}></div>
    <div className={`${skeletonBaseClass} h-4 w-32 mx-auto`}></div>
  </div>
);

export const TransactionPanelSkeleton = () => (
  <div className="space-y-3">
    {[1, 2, 3, 4].map(i => (
      <div key={i} className="flex justify-between items-center">
        <div className={`${skeletonBaseClass} h-4 w-24`}></div>
        <div className={`${skeletonBaseClass} h-4 w-40`}></div>
      </div>
    ))}
  </div>
);

export const ButtonSkeleton = ({ width = "w-24", height = "h-10" }) => (
  <div className={`${skeletonBaseClass} ${width} ${height}`}></div>
);

export const GameInfoSkeleton = () => (
  <div className="space-y-4">
    <div className="flex justify-between">
      <div className={`${skeletonBaseClass} h-4 w-16`}></div>
      <div className={`${skeletonBaseClass} h-4 w-20`}></div>
    </div>
    <div className="flex justify-between">
      <div className={`${skeletonBaseClass} h-4 w-20`}></div>
      <div className={`${skeletonBaseClass} h-4 w-16`}></div>
    </div>
    <div className="flex justify-between">
      <div className={`${skeletonBaseClass} h-4 w-14`}></div>
      <div className={`${skeletonBaseClass} h-4 w-24`}></div>
    </div>
  </div>
);

// Composite skeleton for full game layout
export const FullGameSkeleton = ({ gameType = "tictactoe" }) => (
  <div className="max-w-4xl mx-auto p-4">
    <div className={`${skeletonBaseClass} h-8 w-48 mb-6 mx-auto`}></div>

    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <div>
        <GameStatusSkeleton />
        {gameType === "tictactoe" && <GameBoardSkeleton gridSize={3} />}
        {gameType === "risk" && <div className={`${skeletonBaseClass} h-96 w-full`}></div>}
        <div className="flex gap-2 justify-center">
          <ButtonSkeleton />
          <ButtonSkeleton />
        </div>
      </div>

      <div className="space-y-4">
        <PlayerInfoSkeleton />
        <PlayerInfoSkeleton />
        <GameInfoSkeleton />
      </div>
    </div>
  </div>
);

export default {
  GameBoardSkeleton,
  PlayerInfoSkeleton,
  GameStatusSkeleton,
  TransactionPanelSkeleton,
  ButtonSkeleton,
  GameInfoSkeleton,
  FullGameSkeleton
};